const key_userInfo="liuzhi_cloud_userInfo";
const key_router_num="liuzhi_cloud_router_num";
const key_verifyJudges="liuzhi_cloud_VerifyJudges";
// const key_signUpInfo="fl_cloud_signUpInfo";

let data={
	/**
	 * [保存用户信息]
	 * @param {[userInfo]} userInfo  [用户信息]
	 */
	saveUserInfo:function(userInfo){
		window.sessionStorage.setItem(key_userInfo,JSON.stringify(userInfo));
	},
	/**
	 * [得到用户信息]
	 */
	getUserInfo:function(){
		return JSON.parse(window.sessionStorage.getItem(key_userInfo))||{};
	},

	/**
	 * [保存路由跳转次数]
	 */
	saveRouterNum:function(num){
		window.sessionStorage.setItem(key_router_num,JSON.stringify(num));
	},
	/**
	 * [得到路由跳转次数]
	 */
	getRouterNum:function(){
		return JSON.parse(window.sessionStorage.getItem(key_router_num))||0;
	},
	
	/**
	 * 清空所有
	 */
	clear:function() {
		window.sessionStorage.clear();
	}
}

export default data;